import React from "react";
import "./AllService.css";
import xten from "../../assets/xten-logo-footer.png";
import service3 from "../../assets/SERVICE_BG_3.png";

function AllService() {
  return (
    <div>
      <div className="header-all-services">
        <div className="iot-solutions-content">
          <div className="iot-solutions-text">
            <div className="all-services-header">All Services</div>
            <div className="all-services-sub">
              Norem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              vulputate libero et velit interdum, ac aliquet odio mattis. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos.
            </div>
            <div className="iot-solution-button">
              <a href="/" className="read-more-all-service">
                Read More
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="content-all-service">
        <div className="content-head-all-product">
          <div className="xten-detail-content-head">
            <div className="header-xten-all-product">XTEN All Services</div>
            <div className="sub-xten-all-product">
              Qorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu
              turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus
              nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum
              tellus elit sed risus. Maecenas eget condimentum velit, sit amet
              feugiat lectus. Class aptent taciti sociosqu ad litora torquent
              per conubia nostra, per inceptos himenaeos. Praesent auctor purus
              luctus enim egestas, ac scelerisque ante pulvinar.
            </div>
          </div>
          <div className="content-logo-all-product">
            <img src={xten} alt="" />
          </div>
        </div>
        <div className="content-product-text">
          <div className="detail-product">
            <div className="detail-product-content">
              <div className="detail-product-content-head">1. Consult</div>
              <div className="detail-product-content-sub">
                Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                vulputate libero et velit interdum, ac aliquet odio mattis.
                Class aptent taciti sociosqu ad litora torquent per conubia
                nostra, per inceptos himenaeos.
              </div>
            </div>
            <div className="detail-product-content">
              <div className="detail-product-content-head">2. Survey</div>
              <div className="detail-product-content-sub">
                Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                vulputate libero et velit interdum, ac aliquet odio mattis.
                Class aptent taciti sociosqu ad litora torquent per conubia
                nostra, per inceptos himenaeos.
              </div>
            </div>
            <div className="detail-product-content">
              <div className="detail-product-content-head">
                3. Prototype Design
              </div>
              <div className="detail-product-content-sub">
                Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                vulputate libero et velit interdum, ac aliquet odio mattis.
                Class aptent taciti sociosqu ad litora torquent per conubia
                nostra, per inceptos himenaeos.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="detail-about-us">
        <div className="head-detail-about-us">
          <div className="text-head-detail-about-us">
            <div className="text-1-head-detail-about-us">XTEN TECHNOLOGY</div>
            <div className="text-2-head-detail-about-us">
              Qorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu
              turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus
              nec fringilla accumsan, risus sem sollicitudin lacus, ut interdum
              tellus elit sed risus. Maecenas eget condimentum velit, sit amet
              feugiat lectus. Class aptent taciti sociosqu ad litora torquent
              per conubia nostra.
            </div>
            <div className="text-2-head-detail-about-us">
              Qorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam eu
              turpis molestie, dictum est a, mattis tellus. Sed dignissim, metus
              nec fringilla accumsan, risus sem sollicitudin lacus.
            </div>
          </div>
          <div>
            <img
              alt=""
              src={service3}
              className="example-img"
            />
          </div>
        </div>
        <div className="head-detail-about-us">
          <div className="box-detail-about-us">
            <div className="box-head-detail-about-us">4. Wiring</div>
            <div className="box-sub-detail-about-us">
              Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              vulputate libero et velit interdum, ac aliquet odio mattis. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos.
            </div>
          </div>
          <div className="box-detail-about-us">
            <div className="box-head-detail-about-us">5. Engineering</div>
            <div className="box-sub-detail-about-us">
              Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              vulputate libero et velit interdum, ac aliquet odio mattis. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos.
            </div>
          </div>
          <div className="box-detail-about-us">
            <div className="box-head-detail-about-us">6. Configuration</div>
            <div className="box-sub-detail-about-us">
              Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              vulputate libero et velit interdum, ac aliquet odio mattis. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos.
            </div>
          </div>
        </div>
        <div className="head-detail-about-us">
          <div className="box-detail-about-us">
            <div className="box-head-detail-about-us">7. Manage Service</div>
            <div className="box-sub-detail-about-us">
              Qorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              vulputate libero et velit interdum, ac aliquet odio mattis. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos.
            </div>
          </div>
        </div>  
      </div>
    </div>
  );
}

export default AllService;
